(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"]) return;
  try {
    
  class ViewMoreButton extends HTMLElement {
    constructor() {
      super();
      this.scrollToCollection = this.scrollToCollection.bind(this);
      this.addEventListener('click', this.scrollToCollection);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.scrollToCollection();
        }
      });
    }

    scrollToCollection() {
      const target = document.querySelector('#CollectionProductsGrid');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' }, 100);
      }
    }
  }

  customElements.define('view-more-button', ViewMoreButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav extends HTMLElement {
    connectedCallback() {
      let closeTimeout;
      let openTimeout;
      let anyOpen = false;
      let pointerX = 0;
      let pointerY = 0;

      this.addEventListener('pointermove', (e) => {
        pointerX = e.clientX;
        pointerY = e.clientY;
      });

      this.querySelectorAll('.header__menu-item').forEach((item) => {
        // Find the popover via the button's popovertarget attribute
        const btn = item.querySelector('[popovertarget]');
        if (!btn) return;
        const popover = document.getElementById(btn.getAttribute('popovertarget'));
        if (!popover) return;

        // Hover-to-open is for mice only. Touch fires compat mouse events
        // before the click, so a tap would open the panel on mouseenter and
        // then popovertarget's toggle would immediately close it again.
        // Touch and keyboard go through popovertarget alone.
        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(closeTimeout);
          clearTimeout(openTimeout);
          if (anyOpen) {
            // Moving between items once a panel is open stays instant
            popover.classList.add('megamenu--instant');
            requestAnimationFrame(() => popover.classList.remove('megamenu--instant'));
            popover.showPopover();
          } else {
            // Hover intent: open only once the cursor has settled, so a
            // quick sweep across the header doesn't open a panel -- and,
            // because switching is instant once one is open, cascade
            // through all of them. A plain timer isn't enough: crossing a
            // wide item at speed can still outlast it.
            pointerX = e.clientX;
            pointerY = e.clientY;
            let lastX = pointerX;
            let lastY = pointerY;
            const checkIntent = () => {
              if (Math.hypot(pointerX - lastX, pointerY - lastY) < 7) {
                popover.showPopover();
                return;
              }
              lastX = pointerX;
              lastY = pointerY;
              openTimeout = setTimeout(checkIntent, 100);
            };
            openTimeout = setTimeout(checkIntent, 100);
          }
        });

        item.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(openTimeout);
          closeTimeout = setTimeout(() => popover.hidePopover(), 250);
        });

        // Hovering already opened it, so a mouse click shouldn't toggle it
        // shut under the cursor.
        btn.addEventListener('click', (e) => {
          clearTimeout(openTimeout);
          if (e.pointerType === 'mouse' && popover.matches(':popover-open')) {
            e.preventDefault();
          }
        });

        popover.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') clearTimeout(closeTimeout);
        });
        popover.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          closeTimeout = setTimeout(() => popover.hidePopover(), 250);
        });

        popover.addEventListener('toggle', (e) => {
          if (e.newState === 'open') {
            this.#initCarousel(popover);
          }

          // Drives the "active" underline on the open panel's trigger
          btn.setAttribute('aria-expanded', e.newState === 'open');

          // Popovers expose :popover-open but no `open` attribute, so the
          // theme's scroll-lock MutationObserver can't see them. Mirror it.
          popover.toggleAttribute('open', e.newState === 'open');

          anyOpen =
            e.newState === 'open'
              ? true
              : [...document.querySelectorAll('.megamenu')].some((p) =>
                  p.matches(':popover-open'),
                );
        });
      });

      // The lock has to release the moment the shopper wants to move on. The
      // header is fixed, so a panel can be opened anywhere down the page --
      // scrolling anywhere outside the panel dismisses it and unlocks.
      document.addEventListener(
        'wheel',
        (e) => {
          if (e.target?.closest?.('.megamenu')) return;
          document.querySelectorAll('.megamenu').forEach((p) => {
            if (p.matches(':popover-open')) p.hidePopover();
          });
        },
        { passive: true },
      );
    }

    #initCarousel(popover) {
      const carousel = popover.querySelector('[data-carousel]');
      // Guard against missing carousel or already initialised
      if (!carousel || carousel.dataset.emblaReady) return;
      carousel.dataset.emblaReady = 'true';

      const viewport = carousel.querySelector('.megamenu__carousel-slides');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const countEl = carousel.querySelector('[data-carousel-count]');

      const embla = EmblaCarousel(viewport, { loop: true, dragFree: false });

      function updateCount() {
        if (!countEl) return;
        const index = embla.selectedScrollSnap() + 1;
        const total = embla.scrollSnapList().length;
        const pad = (n) => String(n).padStart(2, '0');
        countEl.textContent = `${pad(index)}–${pad(total)}`;
      }

      prevBtn?.addEventListener('click', () => embla.scrollPrev());
      nextBtn?.addEventListener('click', () => embla.scrollNext());
      embla.on('select', updateCount);
      embla.on('reInit', updateCount);
      updateCount();
    }
  }

  class MobileNav extends HTMLElement {
    connectedCallback() {
      // Signals to CSS that the accordion is JS-controlled; without it the
      // groups fall back to plain, unanimated <details>.
      this.dataset.jsReady = '';

      // Tracks the history of panels for back navigation
      this.history = ['root'];
      this.showPanel('root');

      this.#initAccordions();

      // Listen for custom events from the drawer component to reset the panel when the drawer is closed
      this.closest('site-drawer').addEventListener('drawer:closed', () => {
        this.history = ['root'];
        this.showPanel('root');
      });

      this.addEventListener('click', (e) => {
        const open = e.target.closest('[data-nav-open]');
        if (open) {
          this.openPanel(open.dataset.navOpen);
          return;
        }
        if (e.target.closest('[data-nav-back]')) {
          this.goBack();
        }
      });
    }

    openPanel(name) {
      // Avoid duplicate entries in the history stack
      if (this.history[this.history.length - 1] !== name) {
        this.history.push(name);
      }
      this.showPanel(name);
    }

    goBack() {
      // Avoid popping past the root panel
      if (this.history.length > 1) {
        this.history.pop();
      }
      this.showPanel(this.history[this.history.length - 1]);
    }

    showPanel(name) {
      this.querySelectorAll('.mobile-nav__panel').forEach((panel) => {
        const active = panel.dataset.panel === name;
        panel.toggleAttribute('data-active', active);
        // Parked panels are only faded out, so keep them out of the tab
        // order and the screen reader's reading order
        panel.inert = !active;
        // Publishes the active depth so CSS can park every other panel on the
        // correct side (see .mobile-nav__panel rules)
        if (active) this.dataset.depth = panel.dataset.depth ?? '0';
      });
    }

    /* ---------------------------------------------------------------------- */
    /*                             L3 accordion                               */
    /* ---------------------------------------------------------------------- */

    #initAccordions() {
      this.querySelectorAll('.mobile-nav__group').forEach((group) => {
        const summary = group.querySelector('.mobile-nav__group-heading');
        if (!summary) return;

        summary.addEventListener('click', (e) => {
          // Take over from the native toggle: <details> would flip `open`
          // instantly and the content would vanish before it could animate.
          e.preventDefault();
          if (group.dataset.animating) return;

          if (group.open) {
            this.#collapseGroup(group);
          } else {
            this.#expandGroup(group);
          }
        });
      });
    }

    #expandGroup(group) {
      group.open = true;
      // Force a style flush so the 0fr starting position is committed before
      // we flip to 1fr, otherwise the two changes coalesce and it jumps.
      // Deliberately not requestAnimationFrame: that never fires in a
      // background tab, which would leave the group open but unstyled.
      void group.offsetHeight;
      group.setAttribute('data-expanded', '');
    }

    #collapseGroup(group) {
      const content = group.querySelector('.mobile-nav__group-content');
      group.dataset.animating = 'true';
      group.removeAttribute('data-expanded');

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        group.open = false;
        delete group.dataset.animating;
      };

      // Nothing to wait for if motion is reduced or the transition won't run
      if (!content || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }

      // transitionend never fires if the transition doesn't actually run --
      // a background tab freezes them, for instance -- which would otherwise
      // leave the group stuck open and unclickable. Always have a way out.
      const timer = setTimeout(finish, 400);

      content.addEventListener('transitionend', (e) => {
        if (e.propertyName === 'grid-template-rows') finish();
      });
    }
  }

  customElements.define('header-nav', HeaderNav);
  customElements.define('mobile-nav', MobileNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-at-home-camp"]) return;
  try {
    
    Garnish.$doc.ready(function () {
        var productTiles = $('.product-tile')

        $.each(productTiles, function (i, el) {
            new SP.ProductTile(el);
        });
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideshowCarousel extends HTMLElement {
    connectedCallback() {
      if (window.EmblaCarousel) {
        this.init();
      } else {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      }
    }

    disconnectedCallback() {
      this.embla?.destroy();
    }

    init() {
      const embla = EmblaCarousel(this.querySelector('.slideshow__viewport'), {
        loop: true,
      });
      const counter = this.querySelector('.slideshow__counter');
      const pad = (number) => String(number).padStart(2, '0');
      const updateCounter = () => {
        counter.textContent = `${pad(embla.selectedScrollSnap() + 1)}–${pad(embla.slideNodes().length)}`;
      };

      this.querySelector('.slideshow__arrow--previous').addEventListener('click', () =>
        embla.scrollPrev(),
      );
      this.querySelector('.slideshow__arrow--next').addEventListener('click', () =>
        embla.scrollNext(),
      );
      // A peeking Slide moves into place rather than following its link.
      this.querySelector('.slideshow__container').addEventListener('click', (event) => {
        const index = embla
          .slideNodes()
          .findIndex((slide) => slide.contains(event.target));
        if (index === embla.selectedScrollSnap()) return;
        event.preventDefault();
        embla.scrollTo(index);
      });
      // Only the current Slide's video plays.
      const playCurrentVideo = () => {
        embla.slideNodes().forEach((slide, index) => {
          slide
            .querySelector('hero-video')
            ?.toggleAttribute('paused', index !== embla.selectedScrollSnap());
        });
      };
      playCurrentVideo();
      embla
        .on('select', updateCounter)
        .on('reInit', updateCounter)
        .on('select', playCurrentVideo)
        .on('reInit', playCurrentVideo);
      this.embla = embla;
    }
  }

  if (!customElements.get('slideshow-carousel')) {
    customElements.define('slideshow-carousel', SlideshowCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
